import React, { SetStateAction } from 'react';
import { CiCirclePlus } from 'react-icons/ci';

import * as S from './styles';
import { DataFormProps, BannerProps } from 'types/InputsGridOfBannersProps';

interface BoxToChoiceBannerProps {
	dataForm: DataFormProps;
	setDataForm: React.Dispatch<SetStateAction<DataFormProps>>;
	banner: BannerProps | null;
	setOpenForm: React.Dispatch<React.SetStateAction<boolean>>;
	deleteBanner: any;
	bannerEditedFunction: any;
	showSizeBanner?: boolean;
	idBanner?: string;
	minWidth?: number;
	minHeight?: number;
}

export default function BoxToChoiceBanner({
	banner,
	setOpenForm,
	deleteBanner,
	bannerEditedFunction,
	minWidth = 1,
	showSizeBanner = false
}: BoxToChoiceBannerProps) {
	return (
		<S.container>
			{showSizeBanner && (
				<S.titleBanners>
					<p>{`${minWidth}px min`}</p>
					<S.line />
				</S.titleBanners>
			)}

			<S.areaSelectImg
				onClick={() => {
					if (banner === null) {
						setOpenForm((value) => !value);
					}
				}}
			>
				<CiCirclePlus />
				<p>Selecionar banner </p>
				{banner !== null && (
					<S.imageBanner>
						<img src={banner.file_path} alt={`imagem ${banner.id}`} />
					</S.imageBanner>
				)}
				{banner !== null && (
					<S.controlsBanner>
						<S.buttons>
							<S.editBtn
								onClick={() => {
									bannerEditedFunction(banner || null);
								}}
							>
								Editar
							</S.editBtn>
							<S.deleteBtn
								onClick={() => {
									deleteBanner(banner?.id);
								}}
							>
								Deletar
							</S.deleteBtn>
						</S.buttons>
					</S.controlsBanner>
				)}
			</S.areaSelectImg>
		</S.container>
	);
}
